module.exports = __webpack_public_path__ + "static/4-067f586a93057365430e8ac99892062e.jpeg";